"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "IMenuPhones", {
  enumerable: true,
  get: function get() {
    return _types.IMenuPhones;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Feedback["default"];
  }
});
var _Feedback = _interopRequireDefault(require("./Feedback"));
var _types = require("./types");